export enum EPipelineActions {
  LOAD_PIPELINES = '[PIPELINES] Load Pipelines',
  LOAD_PIPELINES_SUCCESS = '[PIPELINES] Load Pipelines Success',
  LOAD_PIPELINES_ERROR = '[PIPELINES] Load Pipelines Error',
  REFRESH_PIPELINES = '[PIPELINES] Refresh Pipelines',
  CREATE_PIPELINES = '[PIPELINES] Create Pipelines',
  CREATE_PIPELINES_SUCCESS = '[PIPELINES] Create Pipelines Success',
  CREATE_PIPELINES_ERROR = '[PIPELINES] Create Pipelines Error',
  UPDATE_PIPELINES = '[PIPELINES] Update Pipelines',
  UPDATE_PIPELINES_SUCCESS = '[PIPELINES] Update Pipelines Success',
  UPDATE_PIPELINES_ERROR = '[PIPELINES] Update Pipelines Error',
  DELETE_PIPELINES = '[PIPELINES] Delete Pipelines',
  DELETE_PIPELINES_SUCCESS = '[PIPELINES] Delete Pipelines Success',
  DELETE_PIPELINES_ERROR = '[PIPELINES] Delete Pipelines Error',
}

export enum EPipelineStateStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
  UPDATED = 'updated',
  CRATED = 'created',
}

export interface IPipelineState {
  status: EPipelineStateStatus;
  pipelines: IPipeline[];
  pagination: IPipelinePagination;
  currentProduct?: IPipeline;
  new_campaign_id?: number;
  error: any;
  update_response?: any;
}

export interface IPipeline {
  id: number;
  pipeline: string;
  enabled?: boolean;
  created_by?: string;
}

export interface IPipelinePagination {
  current_page?: number;
  has_more_data?: boolean;
  page_size?: number;
  total_pages_count?: number;
  has_previous?: boolean;
  total_count?: number;
  type?: string;
}
